"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectDictationInterims = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _Localize = _interopRequireDefault(require("../Localization/Localize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _Constants$DictateSta = _botframeworkWebchatCore.Constants.DictateState,
    DICTATING = _Constants$DictateSta.DICTATING,
    STARTING = _Constants$DictateSta.STARTING,
    STOPPING = _Constants$DictateSta.STOPPING;
var ROOT_CSS = (0, _glamor.css)({
  alignItems: 'center',
  display: 'flex'
});

var connectDictationInterims = function connectDictationInterims() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var dictateInterims = _ref.dictateInterims,
        dictateState = _ref.dictateState,
        language = _ref.language;
    return {
      dictateInterims: dictateInterims,
      dictateState: dictateState,
      language: language
    };
  }].concat(selectors));
}; // TODO: [P3] After speech started, when clicking on the transcript, it should
//       stop the dictation and allow the user to type-correct the transcript


exports.connectDictationInterims = connectDictationInterims;

var _default = connectDictationInterims(function (_ref2) {
  var styleSet = _ref2.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref3) {
  var className = _ref3.className,
      dictateInterims = _ref3.dictateInterims,
      dictateState = _ref3.dictateState,
      styleSet = _ref3.styleSet;
  return dictateState === STARTING || dictateState === STOPPING ? _react.default.createElement("p", {
    className: (0, _classnames.default)(styleSet.dictationInterims + '', ROOT_CSS + '', (className || '') + '', 'status')
  }, dictateState === STARTING && _react.default.createElement(_Localize.default, {
    text: "Starting\u2026"
  })) : dictateState === DICTATING && (dictateInterims.length ? _react.default.createElement("p", {
    className: (0, _classnames.default)(styleSet.dictationInterims + '', ROOT_CSS + '', (className || '') + '', 'dictating')
  }, dictateInterims.map(function (interim, index) {
    return _react.default.createElement("span", {
      key: index
    }, interim, "\xA0");
  })) : _react.default.createElement("p", {
    className: (0, _classnames.default)(styleSet.dictationInterims + '', ROOT_CSS + '', (className || '') + '', 'status')
  }, _react.default.createElement(_Localize.default, {
    text: "Listening\u2026"
  })));
});

exports.default = _default;